import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { toast } from 'sonner';

export const UniversalFormDialog = ({ open, onOpenChange }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    countryCode: '+1',
    phone: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (formData.phone.length > 10) {
      toast.error('Phone number must be maximum 10 digits');
      return;
    }
    
    if (!/^\d+$/.test(formData.phone)) {
      toast.error('Phone number must contain only numbers');
      return;
    }

    toast.success('Thank you! We will contact you shortly.');
    onOpenChange(false);
    setFormData({ name: '', email: '', countryCode: '+1', phone: '', message: '' });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]" data-testid="universal-form-dialog">
        <DialogHeader>
          <DialogTitle className="text-2xl">Register Your Trademark</DialogTitle>
          <DialogDescription>
            Fill out the form below and our expert team will contact you shortly.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 mt-4">
          <div>
            <Label htmlFor="name">Full Name *</Label>
            <Input
              id="name"
              required
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              placeholder="John Doe"
              data-testid="form-name-input"
            />
          </div>
          
          <div>
            <Label htmlFor="email">Email Address *</Label>
            <Input
              id="email"
              type="email"
              required
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              placeholder="john@example.com"
              data-testid="form-email-input"
            />
          </div>
          
          <div>
            <Label htmlFor="phone">Contact Number *</Label>
            <div className="flex gap-2">
              <Select value={formData.countryCode} onValueChange={(value) => setFormData({ ...formData, countryCode: value })}>
                <SelectTrigger className="w-[120px]" data-testid="form-country-code-select">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="+1">+1 (US)</SelectItem>
                  <SelectItem value="+44">+44 (UK)</SelectItem>
                  <SelectItem value="+91">+91 (IN)</SelectItem>
                  <SelectItem value="+61">+61 (AU)</SelectItem>
                  <SelectItem value="+81">+81 (JP)</SelectItem>
                </SelectContent>
              </Select>
              <Input
                id="phone"
                type="tel"
                required
                maxLength={10}
                value={formData.phone}
                onChange={(e) => setFormData({ ...formData, phone: e.target.value.replace(/\D/g, '') })}
                placeholder="1234567890"
                data-testid="form-phone-input"
              />
            </div>
            <p className="text-xs text-muted-foreground mt-1">Max 10 digits, numbers only</p>
          </div>
          
          <div>
            <Label htmlFor="message">Message (Optional)</Label>
            <Textarea
              id="message"
              value={formData.message}
              onChange={(e) => setFormData({ ...formData, message: e.target.value })}
              placeholder="Tell us about your trademark needs..."
              rows={4}
              data-testid="form-message-textarea"
            />
          </div>
          
          <Button type="submit" className="w-full bg-primary hover:bg-primary/90 text-white" data-testid="form-submit-button">
            Submit Application
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};